import { render, staticRenderFns } from "./intelligentPrediction.vue?vue&type=template&id=5dc471a0"
import script from "./intelligentPrediction.vue?vue&type=script&lang=js"
export * from "./intelligentPrediction.vue?vue&type=script&lang=js"
import style0 from "./intelligentPrediction.vue?vue&type=style&index=0&id=5dc471a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports